const state = () => ({
    campaignName: null,
    campaignViewType: null,
    campaignParentName: null,
    campaign: null,
    pledgeId: null,
});

const mutations = {
    setCampaignName(state, campaignName) {
        state.campaignName = campaignName;
    },
    setCampaignParentName(state, campaignName) {
        state.campaignParentName = campaignName;
    },
    setCampaignViewType(state, viewType) {  // New mutation for campaign.view_type
        state.campaignViewType = viewType;
    },
    setCampaign(state, campaign) {
        state.campaign = campaign;
    },
    setPledgeId(state, pledgeId) {
        state.pledgeId = pledgeId;
    },
};

const getters = {
    getCampaignName(state) {
        return state.campaignName;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};
